<template>
  <div :id="`${source}_call_add_credit_modal`" class="proxima_nova">
    <component
      :is="CustomModal"
      :key="visibleKey"
      title="Add Credits"
      :visible="visible"
      :width="'32vw'"
      @update:visible="updateVisible"
    >
      <span class="text-base primary_color">
        You need to be on a Paid Plan to purchase phone numbers
      </span>

      <template #footer>
        <a-button class="primary_medium" @click="handleAddCredits">
          Add Credits
        </a-button>
      </template>
    </component>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { moveToBilling } from "@/src/utils/utils.js";
import CustomModal from "@/src/components/CustomModal.vue";

const props = defineProps({
  source: { type: String, required: true },
  visible: { type: Boolean, required: true },
});

const emit = defineEmits(["update:visible"]);

const updateVisible = (value) => {
  emit("update:visible", value);
};

const handleAddCredits = () => {
  moveToBilling(true);
  updateVisible(false);
};

const visibleKey = computed(() =>
  props.visible ? "modal-open" : "modal-closed",
);
</script>
